import React from 'react';
import CustomSignIn from "../../forms/CustomSignIn/CustomSignIn";
import "./Login.scss"
import Hero from "../../common/Hero/Hero";
import {useTranslation} from "react-i18next";
import OauthAuthenticationSpidButton from "../../OauthAuthentication/OauthAuthenticationSpidButton/OauthAuthenticationSpidButton";

const Login = (props) => {
  const {t} = useTranslation();
  return (
    <section className={"Login w-100"} data-testid={"Login"}>
      <div className="container">
          <Hero isLogin={true} title={t("login.header1")} description={t("login.header2")}/>
          <div className="container-card-login">
            <div className="card-login card-1">
              <CustomSignIn/>
            </div>
            <div className="card-login card-2 spid-container">
              <OauthAuthenticationSpidButton />
            </div>
          </div>
      </div>
    </section>
  )
}
export default Login;
